
import React from "react";
import MenuBar from "@/components/MenuBar";
import InterviewFeed from "@/components/InterviewFeed";

const Proto1Page = () => {
  return (
    <div className="min-h-screen bg-background">
      <MenuBar />
      <div className="max-w-4xl mx-auto px-4 pt-2 md:pt-4 pb-6">
        <InterviewFeed forceRefresh={true} />
      </div>
    </div>
  );
};

export default Proto1Page;
